var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPgk = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7338_16104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.4853 20.753C15.799 25.4393 8.20108 25.4393 3.51471 20.753C-1.17158 16.0667 -1.17158 8.46872 3.51475 3.7824C8.20103 -0.903881 15.0611 -0.166022 19.7474 4.5203C24.4337 9.20658 25.1716 16.0667 20.4853 20.753Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.51367 3.782C8.19996 -0.904277 15.7979 -0.904184 20.4843 3.78205C25.1705 8.46833 25.1705 16.0663 20.4843 20.7526",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.1725 16.4392L9.36675 17.0371H9.99539L9.4868 17.4066L9.68109 18.0045L9.1725 17.6349L8.66391 18.0045L8.85816 17.4066L8.34961 17.0371H8.9782L9.1725 16.4392Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.56483 10.7009L7.88869 11.6974H8.93635L8.08871 12.3132L8.41247 13.3097L7.56483 12.6938L6.71724 13.3097L7.04105 12.3132L6.19336 11.6974H7.24111L7.56483 10.7009Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.56483 18.0056L7.8886 19.0021H8.93635L8.08861 19.6178L8.41247 20.6143L7.56483 19.9984L6.71724 20.6143L7.04095 19.6178L6.19336 19.0021H7.24097L7.56483 18.0056Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6292 13.3103L10.9531 14.3068H12.0008L11.1531 14.9225L11.4769 15.919L10.6292 15.3031L9.78164 15.919L10.1055 14.9225L9.25781 14.3068H10.3055L10.6292 13.3103Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.50233 13.3103L4.82619 14.3068H5.8738L5.02621 14.9225L5.34993 15.919L4.50233 15.3031L3.65469 15.919L3.97855 14.9225L3.13086 14.3068H4.17856L4.50233 13.3103Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0889 9.15308C19.5526 8.61679 18.8557 8.29996 18.1069 8.24554L20.3484 6.50212C19.4557 5.60938 18.2592 5.20621 17.0916 5.29147C16.9518 4.78916 16.6854 4.31469 16.2903 3.91968L15.4049 5.69052C15.3468 5.58468 15.2733 5.48507 15.1836 5.3954C14.6741 4.88601 13.8483 4.88601 13.339 5.3954C12.8296 5.90479 12.8295 6.73063 13.339 7.24002C13.4286 7.32969 13.5283 7.40324 13.6341 7.46136L11.8633 8.34679C12.2584 8.74194 12.7332 9.00862 13.2358 9.1483C13.1502 10.3159 13.553 11.5122 14.4458 12.405L16.4042 9.88696C16.5515 9.74188 16.7461 9.66177 16.9531 9.66177C17.1622 9.66177 17.3587 9.74315 17.5065 9.89104C17.6543 10.0388 17.7357 10.2354 17.7357 10.4444C17.7357 10.6535 17.6543 10.85 17.5065 10.9978L18.2444 11.7357C18.5892 11.3908 18.7792 10.9322 18.7792 10.4444C18.7792 10.0454 18.6519 9.66594 18.4169 9.35226C18.7593 9.44371 19.083 9.62287 19.3511 9.89104C20.1649 10.7047 20.1649 12.0288 19.3511 12.8424L20.089 13.5803C20.6803 12.9891 21.0059 12.203 21.0059 11.3668C21.0058 10.5305 20.6801 9.74437 20.0889 9.15308Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7338_16104"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.267334)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPgk);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/PGK.404b9e16ebd8f5e23f2cec2da1e5d323.svg";